module.exports = __webpack_public_path__ + "img/thaipost.52ea6bc6.png";